import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, removeToken } from './auth';
import { baseUrl } from '@/config/env';

const service = axios.create({
  baseURL: baseUrl, // api 的 base_url
  timeout: 10 * 1000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const token = (config && config.token) || getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  response => response,
  (error) => {
    let isShowNormalError = true;
    let option = {};
    const hideNormalError = () => {
      isShowNormalError = false;
    };
    const setMessageOption = (op) => {
      option = op;
    };
    setTimeout(() => {
      if (isShowNormalError) {
        let text = '';
        const isTimeOut = error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1;
        if (isTimeOut) {
          text = '请求超时';
        } else {
          const errorResponse = error.response;
          const status = errorResponse && errorResponse.status;
          switch (status) {
            case 403:
            case 400:
              text = (errorResponse.data && errorResponse.data.length > 0 && errorResponse.data[0].error) || '';
              break;
            case 404:
              text = '网络错误,请重试';
              break;
            case 500:
              text = '服务器错误';
              break;
            case 401:
              removeToken();
              sessionStorage.clear();
              window.location.reload();
              text = '登录过期';
              break;
            default:
              break;
          }
        }
        if (text) {
          Message({
            message: text,
            type: 'error',
            ...option,
          });
        }
      }
    });
    return Promise.reject({ ...error.response, hideNormalError, setMessageOption});
  },
);

export default service;
